import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { formValueSelector, change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import ShowMap from '../../Common/ShowMap/ShowMap';
import SubCategorySlider from './SubCategory/SubCategorySlider';
import CustomCheckbox from '../../Common/CustomCheckbox/CustomCheckbox';
import ToolTipContent from '../../Common/ToolTipContent/ToolTipContent';
import Loader from '../../Common/Loader/Loader';

import { getBookingSubCategories } from '../../../actions/siteadmin/ManualBooking/getBookingSubCategories';
import { getNearestPreferredPartner } from '../../../actions/siteadmin/ManualBooking/getNearestPreferredPartner';

import refreshIcon from '/public/Icons/refreshIcon.svg';

import messages from '../../../locale/messages';
import NoResult from '/public/Icons/noResult.svg';
import bt from '../../commonStyle.css';


class BookingDetails extends React.Component {

    handleProviderSelection = async (e) => {
        const { change, bookingType } = this.props;
        if (bookingType == 1) {
            change('ManualBookingForm', 'isRandomProviderSelection', e);
            change('ManualBookingForm', 'isPreferredProvider', false);
            change('ManualBookingForm', 'preferredPartnerId', null);
            change('ManualBookingForm', 'preferredPartnerLat', null);
            change('ManualBookingForm', 'preferredPartnerLng', null);
        } else {
            change('ManualBookingForm', 'isRandomProviderSelection', true);
        }

    }

    handleRefresh = () => {
        const { categoryId, lat, lng, getBookingSubCategories, change } = this.props;
        getBookingSubCategories({ categoryId: Number(categoryId), lat, lng }, 'refresh');
        change('ManualBookingForm', 'orderData', null);
        change('ManualBookingForm', 'isPreferredProvider', false);
        change('ManualBookingForm', 'preferredPartnerId', null);
        change('ManualBookingForm', 'preferredPartnerLat', null);
        change('ManualBookingForm', 'preferredPartnerLng', null);
    }

    handleProviderRefetch = async () => {
        const { getNearestPreferredPartner, lat, lng, userId, ordersData, change } = this.props;
        let variables = {
            lat,
            lng,
            userId,
            searchList: '',
            subCategoryId: ordersData?.map((order) => parseInt(order?.subCategoryId))
        };
        document.getElementById('searchList').value = '';
        change('ManualBookingForm', 'preferredPartnerId', null);
        change('ManualBookingForm', 'preferredPartnerLat', null);
        change('ManualBookingForm', 'preferredPartnerLng', null);
        await getNearestPreferredPartner(variables);
    }

    render() {
        const { subCategories, stepTwoCompleted, isRandomProviderSelection, loaders, preferredPartnerLat, preferredPartnerLng, bookingType, isPreferredProvider } = this.props;
        const { sw_lat, sw_lng, ne_lat, ne_lng } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className='commonMapWrapper'>
                <div className='commonMapBox'>
                    {stepTwoCompleted && bookingType != 2 &&
                        <div className='commonMapCheckBoxContainer svgImg'>
                            <CustomCheckbox
                                name={'isRandomProviderSelection'}
                                className='commonCustomCheckBox'
                                containerClassName="commonCustomCheckWithoutLabelFlex"
                                checked={isRandomProviderSelection}
                                onChange={(e) => this.handleProviderSelection(e)}
                            />
                            {formatMessage(messages.autoAssignProvider)}
                            <ToolTipContent label={formatMessage(messages.autoAssignProviderContent)} isBottom={true} />
                        </div>
                    }
                    {stepTwoCompleted && <div className='commonMapFreshIconContainer' onClick={() => { isPreferredProvider ? this.handleProviderRefetch() : this.handleRefresh() }}>
                        <img src={refreshIcon} />
                    </div>}
                    <div className='commonShowMap'>
                        <ShowMap height={'244px'} lat={preferredPartnerLat} lng={preferredPartnerLng} stepTwoCompleted={stepTwoCompleted} sw_lat={sw_lat} sw_lng={sw_lng} ne_lat={ne_lat} ne_lng={ne_lng} />
                    </div>
                </div>
                {stepTwoCompleted &&
                    <div className='commonSubCategorySliderBox'>
                        {!isPreferredProvider && <div className='commonSubCategorySliderHeading'>{formatMessage(messages.selectSubCategory)}</div>}
                        {loaders?.refresh || loaders?.stepTwo ?
                            <div className={cx(bt.spaceTop3, bt.space3)}>
                                <Loader type="circle" show={loaders?.refresh} />
                            </div> :
                            subCategories?.length > 0 ? <SubCategorySlider /> : <div className='commonNoResultContainer'>
                                <img src={NoResult} />
                                {formatMessage(messages.noResult)}
                            </div>}
                    </div>}
            </div>
        )
    }
}

const selector = formValueSelector('ManualBookingForm');
const mapState = (state) => ({
    subCategories: selector(state, 'subCategories'),
    stepTwoCompleted: selector(state, 'stepTwoCompleted'),
    bookingType: selector(state, 'bookingType'),
    isPreferredProvider: selector(state, 'isPreferredProvider'),
    isRandomProviderSelection: selector(state, 'isRandomProviderSelection'),
    loaders: selector(state, 'loaders'),
    categoryId: selector(state, 'categoryId'),
    preferredPartnerLat: selector(state, 'preferredPartnerLat'),
    preferredPartnerLng: selector(state, 'preferredPartnerLng'),
    ordersData: selector(state, 'orderData'),
    userId: selector(state, 'userId'),
    lat: selector(state, 'lat'),
    lng: selector(state, 'lng'),
    sw_lat: selector(state, 'sw_lat'),
    sw_lng: selector(state, 'sw_lng'),
    ne_lat: selector(state, 'ne_lat'),
    ne_lng: selector(state, 'ne_lng')
});

const mapDispatch = {
    change,
    getBookingSubCategories,
    getNearestPreferredPartner
}

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(BookingDetails)));